import { SyntheticEvent } from 'react'
import styled from 'styled-components'
import { SUPER_CUT_MIME_TYPES } from '../../../constants'
import CreationToolGradient from '../../../types/gradient'
import { getUrlMimeType } from '../../../utils/get-source-info'
import { GradientButton } from '../../buttons'
import { TextInput } from '../../typography'
import { VimeoIcon, YoutubeIcon } from '../../welcome/url/icons'

const Container = styled.div`
    align-items: center;
    display: flex;
    width: 100%;
`

const FileButton = styled(GradientButton)`
    height: 36px;
    margin-right: 30px;
    width: 200px;
`

const UrlInput = styled(TextInput)`
    width: 100%;
`

type Props = {
    onChange: (source: File | string) => void
}

const CreationNewCaptureInputs = ({ onChange }: Props) => {
    const onFileInput = (e: SyntheticEvent<HTMLInputElement, Event>) => {
        const { files } = e.currentTarget
        if (files) {
            onChange(files[0])
            e.currentTarget.value = ''
        }
    }

    const onUrlInput = (e: SyntheticEvent<HTMLInputElement, Event>) => {
        const { value = '' } = e.currentTarget
        const mimeType = getUrlMimeType(value.trim()) // check if valid file url
        if (mimeType) {
            onChange(value.trim())
            e.currentTarget.value = ''
        }
    }

    return (
        <Container>
            <FileButton colors={CreationToolGradient.colors(CreationToolGradient.IndigoPurple)}>
                Choose File
                <input type="file" accept={SUPER_CUT_MIME_TYPES.join(',')} onInput={onFileInput} />
            </FileButton>
            <UrlInput>
                <input type="url" placeholder="Enter any media URL" onInput={onUrlInput} />
                <YoutubeIcon />
                <VimeoIcon />
            </UrlInput>
        </Container>
    )
}

export default CreationNewCaptureInputs
